import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard/auth-guard.service';
import { IndexComponent } from './index/index.component';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: ':authority/goods-publish',
        loadChildren: 'app/module/warpdriver-manage-operation/warpdriver-manage-operation.module#WarpdriverManageOperationModule'
      },
      {
        path: ':authority/editor',
        loadChildren: 'app/module/edit-manage-operation/edit-manage-operation.module#EditManageOperationModule'
      },
      {
        path: ':authority/resource',

        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/patient',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/scientific',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/consumable',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/mentality',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/worker',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      {
        path: ':authority/swordkeeper',
        loadChildren: 'app/module/HFAdmin-manage-operation/HFAdmin-manage-operation.module#HFAdminManageOperationModule'
      },
      // 机构管理
      {
        path: ':authority/owner-organization',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      // 保单管理
      {
        path: ':authority/guarantee',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      // 分析统计
      {
        path: ':authority/statistical',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
      // 评价管理
      {
        path: ':authority/evaluation',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },

      // 耗材管理
      {
        path: ':authority/consumable',
        loadChildren: 'app/module/system-manage-operation/system-manage-operation.module#SystemManageOperationModule'
      },


      // 系统设置
      {
        path: ':authority/mentalseal',
        loadChildren: 'app/module/system-manage-operation/system-manage-operation.module#SystemManageOperationModule'
      },

      // 财务管理
      {
        path: ':authority/finance',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },

      // 指导管理
      {
        path: ':authority/guidance-management',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },

      {
        path: ':authority/echarts-demo',
        loadChildren: 'app/module/demo-list/echarts-demo/echarts-demo.module#EchartsDemoModule'
      },
      // /* 图文资讯 */
      {
        path: ':authority/graphic-information',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
      },
      {
        path: ':authority/famous-doctors',
        loadChildren: 'app/module/famous-doctors/page.module#PagesModule'
      },
      {
        path: ':authority/famous-studio',
        loadChildren: 'app/module/famous-nurse-studio/page.module#PagesModule'
      },
      {
        path: ':authority/gift',
        loadChildren: 'app/module/gift/page.module#PagesModule'
      },
      /* 谣言粉碎机 */
      {
        path: ':authority/rumor',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
      },
      /* 家庭病床预约申请 */
      {
        path: ':authority/sick-bed',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
      },
      /* 服务项目管理 */
      {
        path: ':authority/service-management',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
      },
      /* 在线缴费 */
      {
        path: ':authority/online-pay',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
      },
      /* 统计分析 */
      {
        path: ':authority/statistical-analysis',
        loadChildren: 'app/module/statistical-analysis/page.module#PageModule'
      },
      /* 营养风险筛查 */
      {
        path: ':authority/nutrition',
        loadChildren: 'app/module/new-pages/page.module#PageModule'
        /* 平台信息数据统计 */
      },
      {
        path: ':authority/statistics',
        loadChildren: 'app/module/statistical-analysis/page.module#PageModule'
      },
      /* 优惠卷 */
      {
        path: ':authority/coupon',
        loadChildren: 'app/module/coupon/page.module#PageModule'
      },
      /* 账户余额管理 */
      {
        path: ':authority/account-balance',
        loadChildren: 'app/module/account-balance/page.module#PageModule'
      },
      /* 患教手册 */
      {
        path: ':authority/education',
        loadChildren: 'app/module/education/page.module#PageModule'
      },
      /* 随访管理 */
      {
        path: ':authority/follow',
        loadChildren: 'app/module/april-manage-operation/april-manage-operation.module#AprilManageOperationModule'
      },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class IndexOperationRoutingModule {
  constructor() {
  }
}




// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index-operation-routing.module.ts